import {
  type GraftcodeOnboardingGoalId,
  type GraftcodeOnboardingScenarioId,
  resolveScenarioContentPath,
  resolveSetupModeForGoal,
} from '../graftcode-onboarding.const'

import { resolveDefaultStackForScenario } from './buildOnboardingStackOptions'

const markdownByPath = new Map<string, string>()

export function getCachedOnboardingTutorialMarkdown(path: string): string | null {
  return markdownByPath.get(path) ?? null
}

export function cacheOnboardingTutorialMarkdown(path: string, markdown: string): void {
  markdownByPath.set(path, markdown)
}

export async function prefetchOnboardingTutorialMarkdown(path: string): Promise<string> {
  const cached = markdownByPath.get(path)
  if (cached) {
    return cached
  }

  const response = await fetch(path)
  if (!response.ok) {
    throw new Error(`Failed to load tutorial (${response.status})`)
  }

  const markdown = await response.text()
  markdownByPath.set(path, markdown)
  return markdown
}

export function prefetchOnboardingTutorialMarkdownFireAndForget(path: string | null): void {
  if (!path || getCachedOnboardingTutorialMarkdown(path)) {
    return
  }
  void prefetchOnboardingTutorialMarkdown(path).catch(() => undefined)
}

export async function prefetchOnboardingGuideForScenario(
  scenarioId: GraftcodeOnboardingScenarioId,
  goalId: GraftcodeOnboardingGoalId
): Promise<string> {
  const setupMode = resolveSetupModeForGoal(goalId)
  const stackId = resolveDefaultStackForScenario(scenarioId, setupMode)
  const path = resolveScenarioContentPath(scenarioId, stackId, setupMode)
  if (!path) {
    throw new Error('Tutorial content path is not configured for this scenario')
  }
  return prefetchOnboardingTutorialMarkdown(path)
}
